module.exports = __webpack_public_path__ + "img/transformation.939eece2.gif";